import React from 'react';

import { Svg } from '@lglp/components';

const DefaultPressReleaseIcon: React.FC<DefaultPressReleaseProps> = ({
  className,
  ...rest
}) => {
  return (
    <Svg
      id="icon_communiques"
      data-name="icon communiques"
      viewBox="0 0 86.707 104.067"
      className={className}
      {...rest}
    >
      <g
        id="Groupe_403"
        data-name="Groupe 403"
        transform="translate(-210.65 -314.682)"
      >
        <ellipse
          id="Ellipse_5"
          data-name="Ellipse 5"
          cx="13.335"
          cy="1.496"
          rx="13.335"
          ry="1.496"
          transform="translate(231.555 415.757)"
          fill="#efefef"
        />
        <g id="Groupe_402" data-name="Groupe 402">
          <g
            id="Groupe_400"
            data-name="Groupe 400"
            transform="translate(-0.44 0.417)"
          >
            <path
              id="Tracé_1480"
              data-name="Tracé 1480"
              d="M252.733,346.7H228a1.32,1.32,0,0,1-1.32-1.32h0a1.32,1.32,0,0,1,1.32-1.32h24.731a1.32,1.32,0,0,1,1.32,1.32h0A1.32,1.32,0,0,1,252.733,346.7Z"
              transform="translate(0.081 -0.094)"
              fill="#fff"
            />
            <path
              id="Tracé_1481"
              data-name="Tracé 1481"
              d="M260.9,355.488H219.835a1.32,1.32,0,0,1-1.32-1.32h0a1.32,1.32,0,0,1,1.32-1.32H260.9a1.32,1.32,0,0,1,1.32,1.32h0A1.32,1.32,0,0,1,260.9,355.488Z"
              transform="translate(0 -0.122)"
              fill="#fff"
            />
            <path
              id="Tracé_1482"
              data-name="Tracé 1482"
              d="M260.9,364.273H219.835a1.32,1.32,0,0,1-1.32-1.32h0a1.32,1.32,0,0,1,1.32-1.32H260.9a1.32,1.32,0,0,1,1.32,1.32h0A1.32,1.32,0,0,1,260.9,364.273Z"
              transform="translate(0 -0.15)"
              fill="#fff"
            />
            <rect
              id="Rectangle_353"
              data-name="Rectangle 353"
              width="43.705"
              height="2.64"
              rx="1.32"
              transform="translate(218.515 370.24)"
              fill="#fff"
            />
            <path
              id="Tracé_1483"
              data-name="Tracé 1483"
              d="M260.9,381.843H219.835a1.32,1.32,0,0,1-1.32-1.32h0a1.32,1.32,0,0,1,1.32-1.32H260.9a1.32,1.32,0,0,1,1.32,1.32h0A1.32,1.32,0,0,1,260.9,381.843Z"
              transform="translate(0 -0.205)"
              fill="#fff"
            />
            <path
              id="Tracé_1484"
              data-name="Tracé 1484"
              d="M294.653,323.889l-23.3-5.413a3.655,3.655,0,0,1,.086.781v25.436l4.661,1.079a1.316,1.316,0,1,1-.6,2.563l-4.063-.941v6.289l10.627,2.462a1.316,1.316,0,1,1-.6,2.563l-10.03-2.324v6.289l8.638,2a1.316,1.316,0,1,1-.6,2.563l-8.041-1.863v6.289l6.65,1.541a1.316,1.316,0,1,1-.6,2.563l-6.052-1.4v6.289l4.661,1.08a1.316,1.316,0,1,1-.6,2.563l-4.064-.942V394.09a3.664,3.664,0,0,1-3.669,3.657H249.492l26.46,6.145a3.669,3.669,0,0,0,4.406-2.732l17.036-72.879A3.656,3.656,0,0,0,294.653,323.889Z"
              transform="translate(0.307)"
              fill="#ffcb05"
            />
            <path
              id="Tracé_1485"
              data-name="Tracé 1485"
              d="M277.083,347.446a1.321,1.321,0,0,0-.987-1.585l-4.661-1.083v2.71l4.063.944A1.32,1.32,0,0,0,277.083,347.446Z"
              transform="translate(0.229 -0.098)"
              fill="#fff"
            />
            <path
              id="Tracé_1486"
              data-name="Tracé 1486"
              d="M283.049,357.851a1.32,1.32,0,0,0-.987-1.584l-10.627-2.47v2.71l10.03,2.331A1.32,1.32,0,0,0,283.049,357.851Z"
              transform="translate(0.248 -0.129)"
              fill="#fff"
            />
            <path
              id="Tracé_1487"
              data-name="Tracé 1487"
              d="M281.06,366.408a1.32,1.32,0,0,0-.987-1.584l-8.638-2.008v2.71l8.041,1.869A1.32,1.32,0,0,0,281.06,366.408Z"
              transform="translate(0.241 -0.157)"
              fill="#fff"
            />
            <path
              id="Tracé_1488"
              data-name="Tracé 1488"
              d="M279.072,374.965a1.32,1.32,0,0,0-.987-1.584l-6.65-1.546v2.71l6.052,1.407A1.321,1.321,0,0,0,279.072,374.965Z"
              transform="translate(0.235 -0.185)"
              fill="#fff"
            />
            <path
              id="Tracé_1489"
              data-name="Tracé 1489"
              d="M277.083,383.522a1.32,1.32,0,0,0-.987-1.584l-4.661-1.084v2.71l4.064.945A1.32,1.32,0,0,0,277.083,383.522Z"
              transform="translate(0.229 -0.213)"
              fill="#fff"
            />
            <g
              id="Groupe_399"
              data-name="Groupe 399"
              transform="translate(211.09 314.265)"
            >
              <path
                id="Tracé_1490"
                data-name="Tracé 1490"
                d="M229.041,314.356a.45.45,0,0,1,.047-.018A.378.378,0,0,0,229.041,314.356Z"
                transform="translate(-211.09 -314.265)"
                fill="#111"
              />
              <path
                id="Tracé_1491"
                data-name="Tracé 1491"
                d="M225.961,325.341V314.533l-13.832,11.89h12.75A1.083,1.083,0,0,0,225.961,325.341Z"
                transform="translate(-211.09 -314.265)"
                fill="#003da5"
              />
              <path
                id="Tracé_1492"
                data-name="Tracé 1492"
                d="M265.977,316.757a1.168,1.168,0,0,1,1.169,1.165v74.822a1.168,1.168,0,0,1-1.169,1.165H214.759a1.168,1.168,0,0,1-1.169-1.165V332.1h12.6a5.509,5.509,0,0,0,5.512-5.493v-9.852h34.277m-36.519-2.492a1.094,1.094,0,0,0-.258.035v12.309a3.01,3.01,0,0,1-3.012,3h-14.4v0h-.542a.773.773,0,0,0-.16.526v62.6a3.663,3.663,0,0,0,3.669,3.657h51.218a3.663,3.663,0,0,0,3.669-3.657V317.922a3.663,3.663,0,0,0-3.669-3.657H229.458Z"
                transform="translate(-211.09 -314.265)"
                fill="#003da5"
              />
            </g>
          </g>
          <g id="Groupe_401" data-name="Groupe 401">
            <path
              id="Tracé_1493"
              data-name="Tracé 1493"
              d="M259.357,338.682l-27.53,24.835-12.177-4.284Z"
              fill="#ffcb05"
            />
            <path
              id="Tracé_1494"
              data-name="Tracé 1494"
              d="M231.827,363.517l4.091,11.888,23.439-36.723Z"
              fill="#d6a405"
            />
            <path
              id="Tracé_1495"
              data-name="Tracé 1495"
              d="M259.357,338.682l-5.776,32.343-15.931-5.679Z"
              fill="#ffcb05"
            />
            <path
              id="Tracé_1496"
              data-name="Tracé 1496"
              d="M237.65,365.346,235.918,375.4l7.481-8.01Z"
              fill="#aa7f05"
            />
          </g>
        </g>
      </g>
    </Svg>
  );
};

type DefaultPressReleaseProps = {
  className?: string;
};

export default DefaultPressReleaseIcon;
